/**
 * When noScroll is set (mostly done by modals) we don't scroll to the top of our page.
 */
exports.shouldUpdateScroll = ({ routerProps, prevRouterProps = {} }) => {
  const { location } = routerProps;
  const { location: prevLocation } = prevRouterProps;

  return !(
    (location && location.state && location.state.noScroll) ||
    (prevLocation && prevLocation.state && prevLocation.state.noScroll)
  );
};

exports.onClientEntry = function () {
  require.ensure(['@sentry/react'], function (require) {
    const Sentry = require('@sentry/react');
    Sentry.init({
      dsn: 'https://ae2ceaf785de4891a118354b4f277046@o4510138737819648.ingest.de.sentry.io/4510138738999376',
      sendDefaultPii: true,
    });
  });
};
